import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Vision = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="vision icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4 10.8C29.7012 10.8 35.6248 13.727 39.0668 16.4664C42.0075 18.807 44.4 22.4553 44.4 24.6009C44.4 27.0561 40.856 31.1717 39.1396 32.7797C35.2697 36.4041 29.6807 38.4 23.4 38.4C17.1198 38.4 11.5303 36.4041 7.66092 32.7802C5.94451 31.1717 2.39999 27.0571 2.39999 24.6009C2.39999 22.4547 4.7925 18.807 7.73322 16.4664C11.1752 13.727 17.0988 10.8 23.4 10.8ZM23.4 36.0232C29.0759 36.0232 34.0897 34.2542 37.5176 31.0436C39.9452 28.7689 42.0258 25.5994 42.0258 24.6009C42.0258 23.4824 40.2976 20.4826 37.5899 18.3278C34.4609 15.838 29.0904 13.178 23.4 13.178C17.7096 13.178 12.3386 15.838 9.21006 18.3278C6.50244 20.482 4.77416 23.4824 4.77416 24.6009C4.77416 25.5999 6.85479 28.7694 9.28237 31.0436C12.7103 34.2542 17.7241 36.0232 23.4 36.0232ZM23.3999 15.681C21.0436 15.681 18.9068 16.6044 17.3135 18.101L18.9937 19.7841C20.1571 18.7159 21.7013 18.0584 23.3999 18.0584C27.0027 18.0584 29.9332 20.9923 29.9332 24.6C29.9332 28.2072 27.0027 31.1422 23.3999 31.1422C19.7977 31.1422 16.8672 28.2072 16.8672 24.6C16.8672 24.1726 16.9115 23.756 16.9897 23.3513H14.5902C14.533 23.7603 14.4931 24.1748 14.4931 24.6C14.4931 29.525 18.4811 33.5196 23.3999 33.5196C28.3188 33.5196 32.3074 29.525 32.3074 24.6C32.3074 19.6755 28.3188 15.681 23.3999 15.681ZM23.4009 21.7135C24.9921 21.7135 26.2828 23.0065 26.2828 24.6004C26.2828 26.1938 24.9921 27.4868 23.4009 27.4868C21.8086 27.4868 20.5179 26.1938 20.5179 24.6004C20.5179 23.0065 21.8086 21.7135 23.4009 21.7135Z"
    />
  </svg>
)
